<template>
  <div>
    <v-row>
      <v-col cols="3">
        {{ createdAt }}
        <br />
        {{ note.postedByUser.fullName }}
      </v-col>
      <v-col cols="9">
        {{ note.comment }}
      </v-col>
    </v-row>
  </div>
</template>

<script lang="js">
  export default {
    name: 'NoteItem',
    props: {
      note: {
        required: true,
        type: Object,
      },
    },
    computed: {
      createdAt() {
        return new Date(this.note.createdAt).toLocaleString();
      },
    },
  };
</script>
